module.exports = __webpack_public_path__ + "static/media/ticket-gradient.4d92ae06.svg";